import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyou-form',
  templateUrl: './thankyou-form.component.html',
  styleUrls: ['./thankyou-form.component.css']
})
export class ThankyouFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
